<template>
    <ClientOnly>
        <!-- PC端弹窗 -->
        <el-dialog
            v-if="!isMobile"
            v-model="visible"
            @close="handleClose"
            class="vip-modal"
            :show-close="false"
            :close-on-click-modal="true"
            width="90vw"
            top="5vh"
        >
            <!-- 主内容区域 - 左右两栏布局 -->
            <div
                class="vip-content-wrapper"
                :class="{ 'center-mode': !isMonthlyChatMember }"
            >
                <!-- 关闭按钮 -->
                <button class="close-button" @click="handleClose">
                    <svg
                        class="w-[20px] h-[20px] text-white"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15 5L5 15M5 5L15 15"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>

                <!-- 左侧：角色图片区域 - 仅月度会员显示 -->
                <div
                    v-if="isMonthlyChatMember"
                    class="vip-left-section"
                    :style="{
                        backgroundImage: `url(${characterBackground})`,
                    }"
                >
                    <!-- 底部角色信息 -->
                    <div class="character-info">
                        <h3 class="character-name">{{ characterName }}</h3>
                        <div class="character-messages">
                            <div
                                v-for="(message, index) in selectedMessages"
                                :key="index"
                                class="message-item"
                            >
                                <img
                                    :src="characterAvatar"
                                    :alt="characterName"
                                    class="message-avatar"
                                />
                                <p class="message-text">
                                    {{ message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧：VIP信息区域 -->
                <div class="vip-right-section">
                    <!-- 背景装饰图 -->
                    <div class="background-decoration"></div>

                    <!-- 内容区域 -->
                    <div class="vip-content">
                        <!-- 标题和图标 -->
                        <div class="vip-header">
                            <img
                                src="https://static.weryai.com/growth/image/weryai_a655b2df4cfa4f1df92f5458a2380738.png"
                                alt="皇冠"
                                class="crown-icon"
                            />
                            <h2 class="vip-title">
                                {{ t('vip.respectedVipMember') }}
                            </h2>
                        </div>

                        <!-- 用户信息卡片 -->
                        <ChatMemberInfoCard
                            class="w-full max-w-[480px] mb-[20px]"
                        />

                        <!-- 方案和天数信息 - 并列两个卡片 -->
                        <div class="plan-info-row">
                            <!-- 当前方案 -->
                            <div class="plan-card">
                                <p class="plan-label">
                                    {{ t('vip.currentPlan') }}
                                </p>
                                <div class="plan-content">
                                    <span class="plan-name">{{
                                        subscriptionType
                                    }}</span>
                                    <span class="plan-badge">PRO</span>
                                </div>
                            </div>

                            <!-- 剩余天数 -->
                            <div class="plan-card">
                                <p class="plan-label">
                                    {{ t('vip.remainingDays') }}
                                </p>
                                <p class="remaining-days">
                                    {{ remainingDaysText }}
                                </p>
                            </div>
                        </div>

                        <!-- 已解锁的尊享权益 -->
                        <div class="benefits-section">
                            <div class="benefits-title-wrapper">
                                <div class="benefits-title-line"></div>
                                <h3 class="benefits-title">
                                    {{ t('vip.unlockedBenefits') }}
                                </h3>
                            </div>

                            <!-- 权益列表 - 2列3行 -->
                            <div class="benefits-grid">
                                <div
                                    v-for="(benefit, index) in benefits"
                                    :key="index"
                                    class="benefit-item"
                                >
                                    <img
                                        :src="benefit.icon"
                                        :alt="benefit.text"
                                        class="benefit-icon"
                                    />
                                    <span class="benefit-text">{{
                                        benefit.text
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 升级年度会员（仅月度会员显示） -->
                        <div v-if="isMonthlyChatMember" class="upgrade-section">
                            <div class="upgrade-info">
                                <h3 class="upgrade-title">
                                    {{ t('vip.upgradeToYearlyMember') }}
                                </h3>
                                <p class="upgrade-desc">
                                    {{ t('vip.extendValidityDays') }}
                                </p>
                            </div>
                            <div class="upgrade-right">
                                <span class="upgrade-price">$119.94</span>
                                <button
                                    class="upgrade-btn"
                                    @click="handleUpgradeToYearly"
                                >
                                    {{ t('vip.upgrade') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 移动端：Drawer抽屉 -->
        <el-drawer
            v-else
            v-model="visible"
            direction="btt"
            :show-close="false"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :size="'auto'"
            class="vip-drawer"
            @close="handleClose"
        >
            <div class="vip-drawer-content">
                <!-- 主容器 -->
                <div class="vip-mobile-wrapper">
                    <!-- 关闭按钮 -->
                    <button class="mobile-close-button" @click="handleClose">
                        <svg
                            class="w-[9px] h-[9px] text-white"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15 5L5 15M5 5L15 15"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>

                    <!-- 标题区域 -->
                    <div class="vip-header-mobile">
                        <img
                            src="https://static.weryai.com/growth/image/weryai_a655b2df4cfa4f1df92f5458a2380738.png"
                            alt="皇冠"
                            class="crown-icon-mobile"
                        />
                        <h2 class="vip-title-mobile">
                            {{ t('vip.unlockVipBenefits') }}
                        </h2>
                    </div>

                    <!-- 用户信息卡片 -->
                    <ChatMemberInfoCard class="w-full mb-[10px]" />

                    <!-- 方案和天数信息 - 并列两个卡片 -->
                    <div class="plan-info-row-mobile">
                        <!-- 当前方案 -->
                        <div class="plan-card-mobile">
                            <p class="plan-label-mobile">
                                {{ t('vip.currentPlan') }}
                            </p>
                            <div class="plan-content-mobile">
                                <span class="plan-name-mobile">{{
                                    subscriptionType
                                }}</span>
                                <span class="plan-badge-mobile">PRO</span>
                            </div>
                        </div>

                        <!-- 剩余天数 -->
                        <div class="plan-card-mobile">
                            <p class="plan-label-mobile">
                                {{ t('vip.remainingDays') }}
                            </p>
                            <p class="remaining-days-mobile">
                                {{ remainingDaysText }}
                            </p>
                        </div>
                    </div>

                    <!-- 已解锁的尊享权益 -->
                    <div class="benefits-section-mobile">
                        <div class="benefits-title-wrapper-mobile">
                            <div class="benefits-title-line-mobile"></div>
                            <h3 class="benefits-title-mobile">
                                {{ t('vip.unlockedBenefits') }}
                            </h3>
                        </div>

                        <!-- 权益列表 - 2列3行 -->
                        <div class="benefits-grid-mobile">
                            <div
                                v-for="(benefit, index) in benefits"
                                :key="index"
                                class="benefit-item-mobile"
                            >
                                <img
                                    :src="benefit.icon"
                                    :alt="benefit.text"
                                    class="benefit-icon-mobile"
                                />
                                <span class="benefit-text-mobile">{{
                                    benefit.text
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 升级年度会员（仅月度会员显示） -->
                    <div
                        v-if="isMonthlyChatMember"
                        class="upgrade-section-mobile"
                    >
                        <div class="upgrade-info-mobile">
                            <h3 class="upgrade-title-mobile">
                                {{ t('vip.upgradeToYearlyMember') }}
                            </h3>
                            <p class="upgrade-desc-mobile">
                                {{ t('vip.extendValidityDays') }}
                            </p>
                        </div>
                        <div class="upgrade-right-mobile">
                            <span class="upgrade-price-mobile">$119.94</span>
                            <button
                                class="upgrade-btn-mobile"
                                @click="handleUpgradeToYearly"
                            >
                                {{ t('vip.upgrade') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </ClientOnly>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useUserStore } from '~/stores/user'
import { useI18n } from '~/composables/useI18n'
import ChatMemberInfoCard from '~/components/VIP/ChatMemberInfoCard.vue'
import { getGoodsListApi } from '~/api/common'
import { emitUpgradeOrder, emitOpenAirwallexPayModal } from '~/utils/emitter'

const { t } = useI18n()

// Props
interface Props {
    modelValue: boolean
    characterData?: any // 角色数据，和 MessageItem 结构一致
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
    characterData: undefined,
})

// Emits
const emit = defineEmits<{
    'update:modelValue': [value: boolean]
    renew: []
}>()

// 弹窗显示状态
const visible = computed({
    get: () => props.modelValue,
    set: value => emit('update:modelValue', value),
})

// 检测是否为移动端
const isMobile = ref(false)

const checkMobile = () => {
    if (import.meta.client) {
        isMobile.value = window.innerWidth < 768
    }
}

// 用户store
const userStore = useUserStore()

// 会员类型（根据chat_sub_info的period_type判断）
const subscriptionType = computed(() => {
    const chatSubInfo = userStore.accountSummary?.chat_sub_info
    if (!chatSubInfo || !chatSubInfo.period_type) return t('vip.member')

    // MONTHLY 月费，YEARLY 年费
    if (chatSubInfo.period_type === 'YEARLY') {
        return t('vip.yearlyMember')
    } else if (chatSubInfo.period_type === 'MONTHLY') {
        return t('vip.monthlyMember')
    }
    return t('vip.member')
})

// 是否为月度会员（用于显示升级区块）
const isMonthlyChatMember = computed(() => {
    const chatSubInfo = userStore.accountSummary?.chat_sub_info
    return chatSubInfo?.period_type === 'MONTHLY'
})

// 点击升级到年度会员
const handleUpgradeToYearly = async () => {
    try {
        const res: any = await getGoodsListApi()
        const yearlyGoods =
            res?.status === 200
                ? res?.data?.chat_annual_plan_shelf?.goods?.[0]
                : null
        if (!yearlyGoods) return

        const payment_style = res?.data?.payment_style || userStore.paymentStyle

        // 如果有 payment_style，打开支付选择弹窗
        if (payment_style) {
            emitOpenAirwallexPayModal({
                goods: yearlyGoods,
                mode: 'pay',
                upgrade: true,
            })
            return
        }
        emitUpgradeOrder(yearlyGoods)
    } catch (error) {
        console.error('获取年度会员商品失败:', error)
    }
}

// 有效期（下次扣费日期）- 直接使用next_billing_date字段
const expireDate = computed(() => {
    const chatSubInfo = userStore.accountSummary?.chat_sub_info
    if (!chatSubInfo || !chatSubInfo.next_billing_date)
        return t('vip.permanent')

    // next_billing_date 已经是 yyyy-mm-dd 格式，直接返回
    return chatSubInfo.next_billing_date
})

// 剩余天数 - 根据next_billing_date计算
const remainingDays = computed(() => {
    const chatSubInfo = userStore.accountSummary?.chat_sub_info
    if (!chatSubInfo || !chatSubInfo.next_billing_date) return null

    // 计算剩余天数
    const now = new Date()
    now.setHours(0, 0, 0, 0) // 设置为当天零点，便于计算天数

    const nextBillingDate = new Date(chatSubInfo.next_billing_date)
    nextBillingDate.setHours(0, 0, 0, 0)

    const diffTime = nextBillingDate.getTime() - now.getTime()
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays > 0 ? diffDays : 0
})

// 剩余天数文本
const remainingDaysText = computed(() => {
    if (remainingDays.value === null) return t('vip.permanent')
    return `${remainingDays.value}${t('vip.daysUnit')}`
})

// 用户信息
const userName = computed(() => userStore.userInfo?.nick_name || '')
const userAvatar = computed(
    () =>
        userStore.userInfo?.avatar ||
        'https://static.weryai.com/growth/image/weryai_e44e2e0332eab2a003546bb2ac831791a1a42d90.png'
)

// 角色相关信息（从传入的数据中获取，如果没有则使用默认值）- 移动端使用
const characterName = computed(
    () => props.characterData?.name || 'Chris Girlfriend'
)
const characterAvatar = computed(
    () =>
        props.characterData?.avatar ||
        'https://static.weryai.com/growth/image/weryai_1faa5886411d9dac6fbd0388bbb50d12.png'
)
const characterBackground = computed(
    () =>
        props.characterData?.background ||
        'https://static.weryai.com/growth/image/weryai_1faa5886411d9dac6fbd0388bbb50d12.png'
)
const characterMessage = computed(
    () => props.characterData?.last_message?.msg || t('vip.characterMessage')
)

// 四组随机文案的多语言key，每组包含两条消息（非会员使用）
const messageGroupKeys = [
    ['vipPromo_missYou_title', 'vipPromo_missYou_text'],
    ['vipPromo_night_title', 'vipPromo_night_text'],
    ['vipPromo_heart_title', 'vipPromo_heart_text'],
    ['vipPromo_punish_title', 'vipPromo_punish_text'],
]

// 月会员升级为年会员专用的随机文案组 key
const upgradeMessageGroupKeys = [
    ['upgradePromo_monthly_title', 'upgradePromo_monthly_text'],
    ['upgradePromo_remember_title', 'upgradePromo_remember_text'],
    ['upgradePromo_serious_title', 'upgradePromo_serious_text'],
    ['upgradePromo_cherish_title', 'upgradePromo_cherish_text'],
]

// 随机选择一组消息的key
const selectedMessageKeys = ref<string[]>([])

// 随机选择的消息内容（计算属性，自动响应语言切换）
const selectedMessages = computed(() => {
    return selectedMessageKeys.value.map(key => t(`vip.${key}`))
})

// 随机选择消息组 - 月会员使用升级文案，其他使用默认文案
const selectRandomMessages = () => {
    const groups = isMonthlyChatMember.value
        ? upgradeMessageGroupKeys
        : messageGroupKeys
    const randomIndex = Math.floor(Math.random() * groups.length)
    const keys = groups[randomIndex]
    if (keys) {
        selectedMessageKeys.value = [...keys]
    }
}

// 会员权益列表（使用图片资源）- 按照Figma设计稿顺序
const benefits = computed(() => [
    {
        icon: 'https://static.weryai.com/growth/image/weryai_b5f2dc04199353a6590d4938bb3cb4d0.png',
        text: t('vip.unlockAllChatModes'),
    },
    {
        icon: 'https://static.weryai.com/growth/image/weryai_44b6744edd0b7329c4a451735d2677ba.png',
        text: t('vip.unlimitedRegeneration'),
    },
    {
        icon: 'https://static.weryai.com/growth/image/weryai_d72fc3c4f3c9e525d076f02e4e4e4efc.png',
        text: t('vip.characterMemoryEnhancement'),
    },
    {
        icon: 'https://static.weryai.com/growth/image/weryai_c5cf5a23c5e3181dce36a983bb8af1ef.png',
        text: t('vip.characterResponseSpeed'),
    },
    {
        icon: 'https://static.weryai.com/growth/image/weryai_0b0975691ab6765e72f364db6e286c75.png',
        text: t('vip.exclusiveMemberBadge'),
    },
    {
        icon: 'https://static.weryai.com/growth/image/weryai_76a0b832972755a8af6f6bad3c075cbb.png',
        text: t('vip.unlimitedChatAllModes'),
    },
])

// 关闭弹窗
const handleClose = () => {
    visible.value = false
}

// 续费
const handleRenew = () => {
    emit('renew')
    handleClose()
}

// 监听弹窗打开，初始化随机文案
watch(visible, (newValue, oldValue) => {
    if (newValue && !oldValue) {
        selectRandomMessages()
        checkMobile()
        if (import.meta.client) {
            window.addEventListener('resize', checkMobile)
        }
    }
})

// 组件挂载
onMounted(() => {
    checkMobile()
    if (import.meta.client) {
        window.addEventListener('resize', checkMobile)
    }
})

// 组件卸载
onUnmounted(() => {
    if (import.meta.client) {
        window.removeEventListener('resize', checkMobile)
    }
})
</script>

<style lang="less" scoped>
/* ==================== PC端样式 ==================== */
/* Dialog 样式重置 */
.vip-modal {
    :deep(.el-dialog) {
        max-width: 1200px;
        background: transparent;
        box-shadow: none;
        margin: 0 auto;
    }

    :deep(.el-dialog__header) {
        display: none;
    }

    :deep(.el-dialog__body) {
        padding: 0;
        background: transparent;
    }

    :deep(.el-overlay) {
        background-color: rgba(0, 0, 0, 0.8);
    }
}

/* 主内容容器 - 左右两栏布局 */
.vip-content-wrapper {
    display: flex;
    min-height: 600px;
    max-width: 100%;
    background: #0d0e12;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
}

/* 年会员居中模式 - 没有左侧卡片时 */
.vip-content-wrapper.center-mode {
    width: 540px;
    margin: 0 auto;
    background: #16171d;
}

/* 左侧区域 */
.vip-left-section {
    flex: 0 0 392px;
    position: relative;
    background: linear-gradient(180deg, #1a1b23 0%, #0d0e12 100%);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;
}

/* 角色信息区域 */
.character-info {
    position: relative;
    z-index: 1;
    padding: 20px;
    background: linear-gradient(
        180deg,
        rgba(13, 14, 18, 0) 0%,
        rgba(13, 14, 18, 0.95) 100%
    );
}

.character-name {
    font-family: Roboto, sans-serif;
    font-weight: 900;
    font-size: 20px;
    line-height: 1.4;
    background: linear-gradient(90.42deg, #ffffff 0.36%, #fdeaa9 99.86%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0 0 16px 0;
}

.character-messages {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.message-item {
    display: flex;
    gap: 10px;
    align-items: flex-start;
}

.message-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
    object-fit: cover;
}

.message-text {
    flex: 1;
    background: #ffffff33;
    backdrop-filter: blur(35.82089614868164px);
    border-radius: 8px;
    padding: 8px 12px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
}

/* 右侧区域 */
.vip-right-section {
    flex: 1;
    position: relative;
    background: #16171d;
    padding: 32px 28px;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
}

/* 关闭按钮 */
.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 100;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    &:active {
        transform: scale(0.9);
    }
}

/* 背景装饰图 */
.background-decoration {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('https://static.weryai.com/growth/image/weryai_66f83912d7753f36a816ca9aaab34582.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    pointer-events: none;
}

.vip-content {
    position: relative;
    z-index: 1;
    // display: flex;
    // flex-direction: column;
    gap: 14px;
    width: 100%;
    max-width: 100%;
}

/* VIP标题区域 */
.vip-header {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    margin-bottom: 30px;
}

.crown-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.vip-title {
    font-family: Roboto, sans-serif;
    font-weight: 800;
    font-size: 20px;
    line-height: 1.171875;
    margin: 0;
    background: linear-gradient(107deg, #ffffff 0%, #fdeaa9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* 用户信息卡片 */
.user-info-card {
    position: relative;
    width: 100%;
    max-width: 480px;
    height: 163px;
    background: linear-gradient(
        134deg,
        rgba(65, 55, 44, 1) 0%,
        rgba(82, 75, 65, 1) 45%,
        rgba(47, 39, 32, 1) 98%
    );
    border: 1px solid transparent;
    background-clip: padding-box;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 14px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 12px;
        padding: 1px;
        background: linear-gradient(
            136deg,
            rgba(112, 109, 98, 1) 0%,
            rgba(60, 51, 41, 1) 22%,
            rgba(98, 95, 91, 1) 58%,
            rgba(41, 39, 36, 1) 77%,
            rgba(68, 61, 56, 1) 100%
        );
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
    }
}

.user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 27px;
    border: 1px solid #ffffff;
    object-fit: cover;
}

.user-name {
    position: absolute;
    top: 30px;
    left: 70px;
    font-family: Roboto, sans-serif;
    font-weight: 800;
    font-size: 17px;
    line-height: 1.171875;
    color: #ffffff;
    margin: 0;
}

.vip-watermark {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 28px;
    height: 28px;
    opacity: 0.2;
    filter: grayscale(100%);
}

.expire-info {
    position: absolute;
    bottom: 20px;
    left: 20px;
}

.expire-label {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 2px 0;
}

.expire-date {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

.active-badge {
    position: absolute;
    bottom: 26px;
    right: 14px;
    padding: 6px 14px;
    background: rgba(255, 214, 50, 0.1);
    border: 1px solid #ffd632;
    border-radius: 20px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 1.5;
    color: #ffd632;
}

/* 方案和天数信息行 */
.plan-info-row {
    display: flex;
    gap: 14px;
    margin-bottom: 14px;
}

.plan-card {
    flex: 1;
    min-width: 0;
    height: 85px;
    background: rgba(10, 10, 10, 0.6);
    border: 1px solid rgba(44, 44, 44, 0.76);
    border-radius: 12px;
    padding: 14px;
    position: relative;
}

.plan-label {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.4);
    margin: 0 0 13px 0;
}

.plan-content {
    display: flex;
    align-items: center;
    gap: 4px;
}

.plan-name {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
}

.plan-badge {
    padding: 2px 12px;
    background: #ffd632;
    border-radius: 20px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5;
    color: #000000;
}

.remaining-days {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

/* 已解锁权益区域 */
.benefits-section {
    width: 100%;
    max-width: 480px;
    min-height: 178px;
    background: rgba(10, 10, 10, 0.6);
    border: 1px solid rgba(44, 44, 44, 0.76);
    border-radius: 12px;
    padding: 14px 17px;
}

.benefits-title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
}

.benefits-title-line {
    width: 1px;
    height: 10px;
    background: #ffd632;
}

.benefits-title {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

/* 权益网格 - 2列3行 */
.benefits-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    row-gap: 12px;
}

.benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 6px;
}

.benefit-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    flex-shrink: 0;
}

.benefit-text {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
    word-break: break-word;
    white-space: normal;
}

/* 升级年度会员区域 */
.upgrade-section {
    width: 100%;
    max-width: 480px;
    margin-top: 14px;
    padding: 16px 20px;
    background: linear-gradient(
        180deg,
        rgba(60, 45, 20, 0.9) 0%,
        rgba(40, 30, 15, 0.95) 100%
    );
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
}

.upgrade-section::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(180deg, #ffe15e 0%, #b8860b 100%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.upgrade-info {
    flex: 1;
}

.upgrade-title {
    color: #ffdc82;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 4px 0;
}

.upgrade-desc {
    color: rgba(255, 255, 255, 0.6);
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 12px;
    margin: 0;
}

.upgrade-right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}

.upgrade-price {
    color: #ffdc82;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 24px;
    font-weight: 700;
}

.upgrade-btn {
    padding: 8px 24px;
    background: #ffdc82;
    border: none;
    border-radius: 8px;
    color: #000;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #ffe99a;
        transform: scale(1.02);
    }

    &:active {
        transform: scale(0.98);
    }
}

/* ==================== 移动端样式 ==================== */
/* Drawer样式重置 */
.vip-drawer {
    :deep(.el-drawer) {
        background: #000000;
        box-shadow: none;
        border-radius: 12px 12px 0 0;
        overflow: hidden;
    }

    :deep(.el-drawer__header) {
        display: none;
    }

    :deep(.el-drawer__body) {
        padding: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background: #000000;
    }
}

.vip-drawer-content {
    width: 100%;
    min-height: 0;
    background: #000000;
}

/* 移动端主容器 */
.vip-mobile-wrapper {
    width: 100%;
    padding: 20px 15px 25px;
    background: #000000;
    position: relative;
}

/* 移动端关闭按钮 */
.mobile-close-button {
    position: absolute;
    top: 22.5px;
    right: 15px;
    width: 21px;
    height: 21px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 10.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    cursor: pointer;
    transition: all 0.2s ease;

    &:active {
        transform: scale(0.9);
    }
}

/* VIP标题区域 */
.vip-header-mobile {
    display: flex;
    align-items: flex-end;
    gap: 7.19px;
    margin-bottom: 26px;
}

.crown-icon-mobile {
    width: 26px;
    height: 26px;
    object-fit: contain;
}

.vip-title-mobile {
    font-family: Roboto, sans-serif;
    font-weight: 800;
    font-size: 21px;
    line-height: 1.171875;
    margin: 0;
    background: linear-gradient(107deg, #ffffff 0%, #fdeaa9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* 用户信息卡片 */
.user-info-card-mobile {
    position: relative;
    width: 100%;
    height: 148.5px;
    background: linear-gradient(
        134deg,
        rgba(65, 55, 44, 1) 0%,
        rgba(82, 75, 65, 1) 45%,
        rgba(47, 39, 32, 1) 98%
    );
    border: 0.5px solid transparent;
    background-clip: padding-box;
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 10px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 12px;
        padding: 0.5px;
        background: linear-gradient(
            136deg,
            rgba(112, 109, 98, 1) 0%,
            rgba(60, 51, 41, 1) 22%,
            rgba(98, 95, 91, 1) 58%,
            rgba(41, 39, 36, 1) 77%,
            rgba(68, 61, 56, 1) 100%
        );
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
    }
}

.user-avatar-mobile {
    width: 40px;
    height: 40px;
    border-radius: 60px;
    border: 0.5px solid #ffffff;
    object-fit: cover;
}

.user-name-mobile {
    position: absolute;
    top: 24.5px;
    left: 65px;
    font-family: Roboto, sans-serif;
    font-weight: 800;
    font-size: 18px;
    line-height: 1.171875;
    color: #ffffff;
    margin: 0;
}

.vip-watermark-mobile {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    opacity: 0.2;
    filter: grayscale(100%);
}

.expire-info-mobile {
    position: absolute;
    bottom: 15px;
    left: 15px;
}

.expire-label-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 2px 0;
}

.expire-date-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

.active-badge-mobile {
    position: absolute;
    bottom: 23px;
    right: 15px;
    padding: 7px 15px;
    background: rgba(255, 214, 50, 0.1);
    border: 0.79px solid #ffd632;
    border-radius: 16px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5;
    color: #ffd632;
}

/* 方案和天数信息行 */
.plan-info-row-mobile {
    display: flex;
    gap: 5px;
    margin-bottom: 10px;
}

.plan-card-mobile {
    flex: 1;
    width: 170px;
    height: 75.5px;
    background: rgba(10, 10, 10, 0.6);
    border: 1px solid rgba(44, 44, 44, 0.76);
    border-radius: 12px;
    padding: 15px;
    position: relative;
}

.plan-label-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.4);
    margin: 0 0 8px 0;
}

.plan-content-mobile {
    display: flex;
    align-items: center;
    gap: 2px;
}

.plan-name-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.5;
    color: #ffffff;
}

.plan-badge-mobile {
    padding: 1.5px 10px;
    background: #ffd632;
    border-radius: 10px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5;
    color: #000000;
}

.remaining-days-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

/* 已解锁权益区域 */
.benefits-section-mobile {
    width: 100%;
    min-height: 153.5px;
    background: rgba(10, 10, 10, 0.6);
    border: 1px solid rgba(44, 44, 44, 0.76);
    border-radius: 12px;
    padding: 15px 14.5px 15px 10px;
}

.benefits-title-wrapper-mobile {
    display: flex;
    align-items: center;
    gap: 4.5px;
    margin-bottom: 15px;
}

.benefits-title-line-mobile {
    width: 1.5px;
    height: 14.5px;
    background: #ffd632;
}

.benefits-title-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 1.5;
    color: #ffffff;
    margin: 0;
}

/* 权益网格 - 2列3行 */
.benefits-grid-mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    row-gap: 12px;
}

.benefit-item-mobile {
    display: flex;
    align-items: flex-start;
    gap: 4.95px;
}

.benefit-icon-mobile {
    width: 23.11px;
    height: 23.11px;
    object-fit: contain;
    flex-shrink: 0;
}

.benefit-text-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #ffffff;
    word-break: break-word;
    white-space: normal;
}

/* 升级年度会员区域 - 移动端 */
.upgrade-section-mobile {
    width: 100%;
    margin-top: 10px;
    padding: 14px 15px;
    background: linear-gradient(
        180deg,
        rgba(60, 45, 20, 0.9) 0%,
        rgba(40, 30, 15, 0.95) 100%
    );
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
}

.upgrade-section-mobile::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(180deg, #ffe15e 0%, #b8860b 100%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.upgrade-info-mobile {
    flex: 1;
    min-width: 0;
}

.upgrade-title-mobile {
    color: #ffdc82;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 2px 0;
}

.upgrade-desc-mobile {
    color: rgba(255, 255, 255, 0.6);
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 11px;
    margin: 0;
}

.upgrade-right-mobile {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.upgrade-price-mobile {
    color: #ffdc82;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 18px;
    font-weight: 700;
}

.upgrade-btn-mobile {
    padding: 6px 16px;
    background: #ffdc82;
    border: none;
    border-radius: 6px;
    color: #000;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:active {
        transform: scale(0.95);
    }
}
</style>
